export var TROLLEY_TEXT = {
    each: 'each',
    estimated: 'est.',
    itemPrice: 'Item price',
    pricePer: 'Price per unit',
    viewLink: 'View product',
};
//# sourceMappingURL=constants.js.map